const actionTypes = {
	SET_DEV_QUESTIONNAIRE: 'SET_DEV_QUESTIONNAIRE',

	TOGGLE_NAV_MENU: 'TOGGLE_NAV_MENU',

	SET_PICKLIST_TYPE_SUCCESS: 'SET_PICKLIST_TYPE_SUCCESS',
	SET_PICKLIST_ITEM_SUCCESS: 'SET_PICKLIST_ITEM_SUCCESS',
	GET_PICKLIST_TYPE_SUCCESS: 'GET_PICKLIST_TYPE_SUCCESS',
	GET_PICKLIST_TYPES_SUCCESS: 'GET_PICKLIST_TYPES_SUCCESS',
	GET_PICKLIST_ITEM_SUCCESS: 'GET_PICKLIST_ITEM_SUCCESS',
	GET_PICKLIST_ITEMS_SUCCESS: 'GET_PICKLIST_ITEMS_SUCCESS',
	SAVE_PICKLIST_TYPE_SUCCESS: 'SAVE_PICKLIST_TYPE_SUCCESS',
	SAVE_PICKLIST_ITEM_SUCCESS: 'SAVE_PICKLIST_ITEM_SUCCESS',

	FETCH_HEIGHT_WEIGHT_TABLE: 'FETCH_HEIGHT_WEIGHT_TABLE',
	DELETE_BENEFICIARY_DURING_SIGN_UP: 'DELETE_BENEFICIARY_DURING_SIGN_UP',

	RESET_USER: 'RESET_USER',
	RESET_CUSTOMER_DETAILS: 'RESET_CUSTOMER_DETAILS',
	RESET_CUSTOMER_POLICY: 'RESET_CUSTOMER_POLICY',
	RESET_CUSTOMER_POLICY_BENEFICIARY: 'RESET_CUSTOMER_POLICY_BENEFICIARY',
	SET_CUSTOMER_DETAILS: 'SET_CUSTOMER_DETAILS',
	SET_CUSTOMER_FAMILY_LIST: 'SET_CUSTOMER_FAMILY_LIST',
	SET_CUSTOMER_POLICY: 'SET_CUSTOMER_POLICY',
	SET_CUSTOMER_POLICIES: 'SET_CUSTOMER_POLICIES',
	SET_CUSTOMER_POLICY_BENEFICIARY: 'SET_CUSTOMER_POLICY_BENEFICIARY',
	SET_TRUSTEE: 'SET_TRUSTEE',
	SET_CUSTOMER_POLICY_BENEFICIARIES: 'SET_CUSTOMER_POLICY_BENEFICIARIES',
	SET_QUESTIONNAIRE: 'SET_QUESTIONNAIRE',
	RESET_QUESTIONNAIRE: 'RESET_QUESTIONNAIRE',
	SET_QUOTING_ASSESSMENT: 'SET_QUOTING_ASSESSMENT',
	FETCH_CUSTOMER_DETAILS: 'FETCH_CUSTOMER_DETAILS',
	FETCH_CUSTOMER_FAMILY_LIST: 'FETCH_CUSTOMER_FAMILY_LIST',
	SAVE_CUSTOMER_DETAILS: 'SAVE_CUSTOMER_DETAILS',
	SAVE_CUSTOMER_FAMILY_LIST: 'SAVE_CUSTOMER_FAMILY_LIST',
	FETCH_PLAN_OPTIONS: 'FETCH_PLAN_OPTIONS',

	FETCH_ADMINS: 'FETCH_ADMINS',
	SET_USER: 'SET_USER',
	SET_CUSTOMER_NOTE: 'SET_CUSTOMER_NOTE',
	FETCH_USER: 'FETCH_USER',
	SAVE_USER: 'SAVE_USER',
	SAVE_USER_ROLE_SUCCESS: 'SAVE_USER_ROLE',
	FETCH_CUSTOMER_PAYMENT: 'FETCH_CUSTOMER_PAYMENT',
	FETCH_CUSTOMER_PAYMENTS: 'FETCH_CUSTOMER_PAYMENTS',
	FETCH_CUSTOMER_UPCOMING_INVOICE: 'FETCH_CUSTOMER_UPCOMING_INVOICE',
	FETCH_CUSTOMER_POLICY: 'FETCH_CUSTOMER_POLICY',
	FETCH_CUSTOMER_POLICY_FREE_TRIAL_MONTHS: 'FETCH_CUSTOMER_POLICY_FREE_TRIAL_MONTHS',
	FETCH_CUSTOMER_POLICY_DOCUMENT_URL: 'FETCH_CUSTOMER_POLICY_DOCUMENT_URL',
	FETCH_CUSTOMER_POLICIES: 'FETCH_CUSTOMER_POLICIES',
	FETCH_UNMAILED_POLICIES: 'FETCH_UNMAILED_POLICIES',
	FETCH_UNMAILED_POLICIES_COUNT: 'FETCH_UNMAILED_POLICIES_COUNT',
	FETCH_CUSTOMER_POLICY_BENEFICIARY: 'FETCH_CUSTOMER_POLICY_BENEFICIARY',
	FETCH_CUSTOMER_POLICY_BENEFICIARIES: 'FETCH_CUSTOMER_POLICY_BENEFICIARIES',
	FETCH_CUSTOMER_POLICY_BENEFICIARY_FORM: 'FETCH_CUSTOMER_POLICY_BENEFICIARY_FORM',
	FETCH_CUSTOMERS: 'FETCH_CUSTOMERS',
	FETCH_SOFT_DECLINED_CUSTOMERS: 'FETCH_SOFT_DECLINED_CUSTOMERS',
	CLEAR_ADJUDICATION_QUEUE: 'CLEAR_ADJUDICATION_QUEUE',
	FETCH_CUSTOMER_CARD: 'FETCH_CUSTOMER_CARD',
	FETCH_INVOICE_CARD: 'FETCH_INVOICE_CARD',
	FETCH_CUSTOMER_NOTE: 'FETCH_CUSTOMER_NOTE',
	FETCH_CUSTOMER_NOTES: 'FETCH_CUSTOMER_NOTES',
	SAVE_CUSTOMER_POLICY: 'SAVE_CUSTOMER_POLICY',
	SAVE_CUSTOMER_POLICY_ANSWER: 'SAVE_CUSTOMER_POLICY_ANSWER',
	SAVE_CUSTOMER_POLICY_BENEFICIARY: 'SAVE_CUSTOMER_POLICY_BENEFICIARY',
	SAVE_CUSTOMER_POLICY_CURRENT_BENEFICIARY: 'SAVE_CUSTOMER_POLICY_CURRENT_BENEFICIARY',
	SAVE_CUSTOMER_NOTE: 'SAVE_CUSTOMER_NOTE',
	UPDATE_CUSTOMER_POLICY: 'UPDATE_CUSTOMER_POLICY',
	DELETE_CUSTOMER_POLICY: 'DELETE_CUSTOMER_POLICY',
	DELETE_CUSTOMER_POLICY_BENEFICIARY: 'DELETE_CUSTOMER_POLICY_BENEFICIARY',
	UPDATE_POLICY_PAPER_STATUS: 'UPDATE_POLICY_PAPER_STATUS',
	RESET_PASSWORD: 'RESET_PASSWORD',
	RESET_CUSTOMER_NOTES: 'RESET_CUSTOMER_NOTES',
	RESET_CUSTOMER_ANSWER_NOTES: 'RESET_CUSTOMER_ANSWER_NOTES',
	SET_PREMIUM_CHANGED: 'SET_PREMIUM_CHANGED',
	FETCH_REFERRER_NAME_BY_REFERRAL_CODE_SUCCESS: 'FETCH_REFERRER_NAME_BY_REFERRAL_CODE_SUCCESS',
	FETCH_REFERRER_NAME_BY_SPOUSAL_REFERRAL_CODE_SUCCESS: 'FETCH_REFERRER_NAME_BY_SPOUSAL_REFERRAL_CODE_SUCCESS',

	SET_QUESTIONNAIRE_NAVIGATION_ENABLED: 'SET_QUESTIONNAIRE_NAVIGATION_ENABLED',
	SET_SELECT_POLICY_OPTIONS_ENABLED: 'SET_SELECT_POLICY_OPTIONS_ENABLED',

	SET_STRIPE: 'SET_STRIPE',
	SET_PAYMENT_DETAILS: 'SET_PAYMENT_DETAILS',
	CREATE_SUBSCRIPTION: 'CREATE_SUBSCRIPTION',
	CREATE_CHARGE: 'CREATE_CHARGE',
	PAY_INVOICE: 'PAY_INVOICE',
	UPDATE_CUSTOMER_EMAIL: 'UPDATE_CUSTOMER_EMAIL',
	UPDATE_CUSTOMER_CARD: 'UPDATE_CUSTOMER_CARD',
	UPDATE_CUSTOMER_PLAN: 'UPDATE_CUSTOMER_PLAN',
	APPROVE_ALL_BENEFICIARIES: 'APPROVE_ALL_BENEFICIARIES',

	FETCH_CUSTOMERS_COUNT: 'FETCH_CUSTOMERS_COUNT',
	FETCH_USER_ACTIVITIES: 'FETCH_USER_ACTIVITIES',
	FETCH_POLICIES_COUNT: 'FETCH_POLICIES_COUNT',
	FETCH_POLICIES: 'FETCH_POLICIES',
	FETCH_FAILED_PAYMENTS_COUNT: 'FETCH_FAILED_PAYMENTS_COUNT',
	FETCH_FAILED_PAYMENTS: 'FETCH_FAILED_PAYMENTS',
	FETCH_EXPIRING_POLICIES_COUNT: 'FETCH_EXPIRING_POLICIES_COUNT',
	FETCH_EXPIRING_POLICIES: 'FETCH_EXPIRING_POLICIES',
	FETCH_MISSING_BENEFICIARY_FORMS_COUNT: 'FETCH_MISSING_BENEFICIARY_FORMS_COUNT',
	FETCH_CUSTOMERS_MISSING_BENEFICIARY_FORMS: 'FETCH_CUSTOMERS_MISSING_BENEFICIARY_FORMS',
	FETCH_BOUNCED_EMAILS_COUNT: 'FETCH_BOUNCED_EMAILS_COUNT',
	FETCH_BOUNCED_EMAILS: 'FETCH_BOUNCED_EMAILS',
	RESOLVE_BOUNCED_EMAIL: 'RESOLVE_BOUNCED_EMAIL',
	FETCH_FINANCIAL_REPORT: 'FETCH_FINANCIAL_REPORT',
	FETCH_REFERRALS: 'FETCH_REFERRALS',

	FETCH_USER_AUTH_SUCCESS: 'FETCH_USER_AUTH_SUCCESS',
	FETCH_USER_AUTH_FAILURE: 'FETCH_USER_AUTH_FAILURE',
	USER_AUTH_LOGOUT: 'USER_AUTH_LOGOUT',
	SET_DIRECT_STATUS_SUCCESS: 'SET_DIRECT_STATUS_SUCCESS',
	SET_CURRENTUSER_HAS_SIGNED_IN: 'SET_CURRENTUSER_HAS_SIGNED_IN',

	FETCH_QUESTION_SUCCESS: 'FETCH_QUESTION_SUCCESS',
	FETCH_RATE_PLUS_MINUS_SUCCESS: 'FETCH_RATE_PLUS_MINUS_SUCCESS',

	VALIDATE_REFERRALCODE_SUCCESS: 'VALIDATE_REFERRALCODE_SUCCESS',
	RESET_CUSTOMER_REFERRALS: 'RESET_CUSTOMER_REFERRALS',
	FETCH_CUSTOMER_REFERRALS_SUCCESS: 'FETCH_CUSTOMER_REFERRALS_SUCCESS',
	GENERATE_NEW_REFERRALCODE_SUCCESS: 'GENERATE_NEW_REFERRALCODE_SUCCESS',
	SET_REFERRALCODE_SUCCESS: 'SET_REFERRALCODE_SUCCESS',
	SET_SPOUSALREFERRALCODE_SUCCESS: 'SET_SPOUSALREFERRALCODE_SUCCESS',
	UPDATE_REMAINING_REFERRALS_SUCCESS: 'UPDATE_REMAINING_REFERRASL_SUCCESS',
	SET_CUSTOMER_REMAINING_REFERRALS: 'SET_CUSTOMER_REMAINING_REFERRALS',
	UPDATE_REFERAL_BALANCE_SUCCESS: 'UPDATE_REFERAL_BALANCE_SUCCESS',
	UPDATE_REFERRAL_ENABLED_SUCCESS: 'UPDATE_REFERRAL_ENABLED_SUCCESS',
	SET_CUSTOMER_REFERRAL_BALANCE: 'SET_CUSTOMER_REFERRAL_BALANCE',
	SEND_REFERRAL_INVITE_EMAIL_SUCCESS: 'SEND_REFERRAL_INVITE_EMAIL_SUCCESS',
	UPDATE_CUSTOMER_REFERREDBY_SUCCESS: 'UPDATE_CUSTOMER_REFERREDBY_SUCCESS',
	FETCH_IS_HARD_DECLINED_SUCCESS: 'FETCH_IS_HARD_DECLINED_SUCCESS',
	FETCH_IS_SOFT_DECLINED_SUCCESS: 'FETCH_IS_SOFT_DECLINED_SUCCESS',
	SEND_SOFT_DECLINED_EMAIL_SUCCESS: 'SEND_SOFT_DECLINED_EMAIL_SUCCESS',
	FETCH_QUESTIONNAIRE_REPORT_SUCCESS: 'FETCH_QUESTIONNAIRE_REPORT_SUCCESS',
	FETCH_POLICY_ANSWER_SUCCESS: 'FETCH_POLICY_ANSWER_SUCCESS',
	RESET_POLICY_ANSWER: 'RESET_POLICY_ANSWER',
	REDIRECT_FROM_ADJUDICATION: 'REDIRECT_FROM_ADJUDICATION',

	CONTACT_US_SUCCESS: 'CONTACT_US_SUCCESS',
	FILE_A_CLAIM_SUCCESS: 'FILE_A_CLAIM_SUCCESS'
};

export default actionTypes;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/actionTypes.ts